import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import { LANGUAGE_KEY } from "constants/common";

import deTranslations from "locales/de.json";
// import enTranslations from "locales/en.json";
// import ruTranslations from "locales/ru.json";

const currentLanguage = localStorage.getItem(LANGUAGE_KEY) || "de";

i18n.use(initReactI18next).init({
  lng: currentLanguage,
  fallbackLng: "de",
  resources: {
    // en: {
    //   translation: enTranslations,
    // },
    // ru: {
    //   translation: ruTranslations,
    // },
    de: {
      translation: deTranslations,
    },
  },
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
